module.exports = __webpack_public_path__ + "img/bay.005fe7d5.png";